"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.error ?? "Login failed");
        return;
      }
      window.location.href = "/admin/dashboard";
    } catch {
      setError("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-leaf-50 via-sand-50 to-leaf-100 px-5">
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-leaf-200/40 blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="mb-6 text-center">
          <a href="/" className="font-display text-3xl font-bold text-leaf-700">
            <span className="mr-1">🌿</span>Ayur
            <span className="text-clay-500">Veda</span>
          </a>
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-3xl bg-white/90 p-8 shadow-2xl shadow-leaf-900/10 backdrop-blur"
        >
          <h1 className="font-display text-3xl font-bold text-leaf-900">
            Admin Login
          </h1>
          <p className="mt-2 text-sm text-leaf-800/70">
            Sign in to manage Meta Pixels &amp; Conversions.
          </p>

          {error && (
            <div className="mt-5 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-red-600">
              {error}
            </div>
          )}

          <label className="mt-6 block text-sm font-medium text-leaf-800">
            Email
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@ayurveda.com"
              className="mt-1.5 w-full rounded-xl border border-leaf-100 bg-sand-50 px-4 py-3 text-leaf-900 outline-none transition-colors placeholder:text-leaf-800/40 focus:border-leaf-500"
            />
          </label>

          <label className="mt-4 block text-sm font-medium text-leaf-800">
            Password
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1.5 w-full rounded-xl border border-leaf-100 bg-sand-50 px-4 py-3 text-leaf-900 outline-none transition-colors placeholder:text-leaf-800/40 focus:border-leaf-500"
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            className="mt-6 w-full rounded-full bg-leaf-600 px-7 py-3.5 font-semibold text-white shadow-lg shadow-leaf-600/30 transition-all hover:bg-leaf-700 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
